import httpService from "../httpService";

const hcCaseScnService = {
  findById(id) {
    return httpService.get(`/hcCaseScn/${id}`);
  },
}

export default hcCaseScnService;



// WEBPACK FOOTER //
// ./src/services/suachuanho/hcCaseScnService.js